import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';

const api = axios.create({
  baseURL: `${API_URL}/api/v1`,
  timeout: 15000,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use(
  (config) => {
    const sessionId = localStorage.getItem('sessionId');
    if (sessionId) {
      config.headers['X-Session-Id'] = sessionId;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// 재시도 로직 (네트워크 오류 시 최대 2회, 1초 딜레이)
const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const axiosWithRetry = async (config, retries = 2) => {
  try {
    return await api(config);
  } catch (error) {
    const isNetworkError = !error.response && (
      error.code === 'ECONNABORTED' ||
      error.message === 'Network Error' ||
      error.message?.includes('fetch failed')
    );
    if (isNetworkError && retries > 0) {
      await sleep(1000);
      return axiosWithRetry(config, retries - 1);
    }
    throw error;
  }
};

api.interceptors.response.use(
  (response) => response.data,
  async (error) => {
    const status = error.response?.status;

    // 401: 세션 만료
    if (status === 401) {
      // 고객 앱에서는 toast 이벤트를 dispatch해 처리 (리다이렉트 없음)
      window.dispatchEvent(new CustomEvent('api:session-expired'));
      return Promise.reject(new Error('세션이 만료되었습니다. 다시 스캔해주세요.'));
    }

    // 500: 서버 오류
    if (status >= 500) {
      window.dispatchEvent(new CustomEvent('api:server-error'));
      return Promise.reject(new Error('서버 오류가 발생했습니다. 잠시 후 다시 시도해주세요.'));
    }

    const message =
      error.response?.data?.message ||
      error.message ||
      '네트워크 오류가 발생했습니다.';
    return Promise.reject(new Error(message));
  }
);

export default api;
